var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJcb = function SvgJcb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61 38"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h61v38H0z",
    "data-name": "Rectangle 2481"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00a551",
    d: "M41.118 20.357c.075 2.222.149 4.518.037 6.777a3.06 3.06 0 0 1-1.444 2.259 4.37 4.37 0 0 1-2.222.482l-2.944-.037-.018-18.85a3.19 3.19 0 0 1 2.26-2.666 41 41 0 0 1 4.3-.148l.074.963v10.7l-.037.037Z",
    "data-name": "Path 656"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0071bb",
    d: "M19.788 19.654v-8.889a3.23 3.23 0 0 1 1.962-2.3c1.445-.445 3.112-.184 4.592-.223.074 1.446 0 3.26.037 4.519l.075 11.59c-.186 1.778.481 4.185-1.742 5.185-1.406.7-3.3.259-4.888.408l-.037-.259V19.654Z",
    "data-name": "Path 657"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.788 20.023a3.22 3.22 0 0 0 2.407 1.407c1.222.112 2.814.222 3.629-.925.556-.593.223-1.407.334-2.185l-.037-1.408a13.6 13.6 0 0 0-2.148-.037c-.407 1.519.667 3.222-1.074 4a1.92 1.92 0 0 1-1.407-.222c-.666-.148-.3-1.222-1.185-.926l-.518-.073Z",
    "data-name": "Path 658"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ec1c24",
    d: "m33.749 9.47.037 18.035a3.28 3.28 0 0 1-1.851 2.111 15.2 15.2 0 0 1-4.7.259l-.075-19a2.9 2.9 0 0 1 1.444-2.148 3.74 3.74 0 0 1 1.926-.519h3.148Z",
    "data-name": "Path 659"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33.452 16.912a4 4 0 0 1 .037.667c-1.111-.3-2.481-.63-3.481.185a1.845 1.845 0 0 0 .593 3.037 5.3 5.3 0 0 0 2.851-.186 1.07 1.07 0 0 1 0 .593h-4.259a2.2 2.2 0 0 1-1.666-1.3 2.28 2.28 0 0 1 .37-2.259 2.16 2.16 0 0 1 1.777-.778Z",
    "data-name": "Path 660"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M41.118 20.357a1.24 1.24 0 0 1-.926.925h-5.185l-.185-.074c0-1.481-.038-2.888.037-4.332h3.3c1.036.111 2.185-.333 2.667.63a.96.96 0 0 1-.149 1.037c-.148.258-.481.3-.555.481a1.53 1.53 0 0 1 1 .852Zm-4.444-3.037a3.6 3.6 0 0 0-.037 1.407c.778-.036 1.778.259 2.3-.332a.73.73 0 0 0-.038-.779c-.596-.518-1.484-.185-2.225-.296m2 2.037a9.8 9.8 0 0 0-2.074-.037 7 7 0 0 0 .073 1.519 5 5 0 0 0 2.222-.223.79.79 0 0 0 .223-.74.77.77 0 0 0-.444-.52Z",
    "data-name": "Path 661"
  })));
};
export { SvgJcb as ReactComponent };
export default "/_next/static/images/jcb.svg";